export const documentRequestTabs = {
  vgm: 'VGM',
  si: 'SI',
  form13: 'Form 13',
};

export const statusColorMap = {
  Accepted: {
    background: '#F6FFF1',
    border: '1px solid #42B900',
    color: '#0F8604',
  },
  Pending: {
    background: '#FFFBDE',
    border: '1px solid #ED8732',
    color: '#E58210',
  },
  Rejected: {
    background: '#FFEBEC',
    border: '1px solid #F5222D',
    color: '#E72626',
  }
};

export enum RequestStatus {
	IN_DRAFT = 'IN_DRAFT',
	PENDING = 'PENDING',
	VERIFIED = 'VERIFIED',
	REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
};

export const getContainerStatus = (status) => {
  switch (status) {
    case RequestStatus.REQUESTED:
    case RequestStatus.PENDING: return {
      background: '#FFFBDE',
      border: '1px solid #ED8732',
      color: '#E58210',
      title: 'Pending',
    }
    case RequestStatus.VERIFIED: return {
      background: '#F6FFF1',
      border: '1px solid #42B900',
      color: '#0F8604',
      title: 'Accepted'
    }
    case RequestStatus.REJECTED: return {
      background: '#FFEBEC',
      border: '1px solid #F5222D',
      color: '#E72626',
      title: 'Rejected'
    }
    default: return {};
  }
};
